import CryptoJS from 'crypto-js';

/**
 * AES Decryption function to match PHP backend encryption
 * @param {string} encryptedText - The encrypted text from PHP backend
 * @param {string} secretKey - The 32-character secret key
 * @returns {string|null} - Decrypted text or null if decryption fails
 */
export function decryptAES(encryptedText, secretKey) {
  try {
    if (!encryptedText) {
      return null;
    }
    
    // Decode base64 to get IV + base64_encoded_ciphertext
    const fullData = atob(encryptedText);
    
    // Extract IV (first 16 bytes) and base64 ciphertext (remaining)
    const ivBinary = fullData.substring(0, 16);
    const ciphertextBase64 = fullData.substring(16);
    
    // Convert IV to WordArray
    const iv = CryptoJS.enc.Latin1.parse(ivBinary);
    
    // Decrypt using the base64 ciphertext directly
    const decrypted = CryptoJS.AES.decrypt(
      ciphertextBase64,
      CryptoJS.enc.Utf8.parse(secretKey),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}

// Default secret key for email decryption
export const DEFAULT_EMAIL_SECRET_KEY = "f8XyL0Qj1RkT9hWz5D2uN3eB7mSaP6vG";

// Convenience function for decrypting emails with default key
export function decryptEmail(encryptedEmail) {
  return decryptAES(encryptedEmail, DEFAULT_EMAIL_SECRET_KEY);
}
